'use strict';

var initialized = false,
	commonElements = require('./../../../app_storefront_core_UI/cartridge/js/common-elements'),
	util = require('./../../../app_storefront_core_UI/cartridge/js/util'),
	header = require('./../../../app_storefront_core_UI/cartridge/js/header'),
	options = {
		classBody: 'js-header-flyout_opened js-utility_opened',
		classHeaderPromoHidden: 'is-header-promotion-hidden',
		selectors: {
			headerPromoSlot: '.js-header-promotion-slot',
			contentAssetWrapper: '.content-asset'
		}
	},
	$cache = {};

/**
 * @private
 * @function
 * @description Initializes cache for component
 */
function initializeCache() {
	$cache.window = $(window);
	$cache.document = $(document);
	$cache.body = $('body');
	$cache.utilityFlyoutLinks = $('.js-utility_flyout-link').filter('[data-utility-popup!=".b-header-login_dropdown"]');
	$cache.utilityFlyoutPopups = $('.js-utility_flyout-item');
	$cache.headerWrapper = $('.js-sticky_header-wrapper');
	$cache.header = $('.js-sticky_header');
	$cache.headerNavigation = $('.b-main_navigation .b-navigation_wrapper');
	$cache.headerNavigationItems = $('.js-navigation-item, .menu-item-toggle');
	$cache.headerNavigationDropdowns = $('.js-main_navigation-dropdown');
	$cache.currentCountry = $('.js-current-country');
	$cache.selectedLocale = $('.js-selected-locale');
}

/**
 * @private
 * @function
 * @description Initializes events for component
 */
function initializeEvents() {

	if (!util.isMobile()) {
		$cache.utilityFlyoutLinks.filter('[data-utility-popup]').off('click');

		$cache.utilityFlyoutLinks
			.on('click', function(e) {
				e.preventDefault();
				var popupSelector = $(this).data('utility-popup'),
					$popup;

				if (!$(this).hasClass('active')) {
					header.closeUtilityPopups();
					closeAllFlyouts(false);

					$(this).addClass('active');
					$cache.body.addClass(options.classBody);

					if (popupSelector) {
						$popup = $cache.utilityFlyoutPopups.filter(popupSelector);

						commonElements.loadLazyIframes($popup);
						$popup.addClass('active');
						$cache.utilityFlyoutPopups.find('#q').focus();
					}
				} else {
					closeAllFlyouts(true);
				}
			});

		$cache.document
			.on('click', function () {
				if (!$cache.body.hasClass('js-utility_opened') && ($cache.selectedLocale.hasClass('active') || $cache.currentCountry.hasClass('active'))) {
					header.closeUtilityPopups();
				}
			})
			.on('click', '.js-utility_flyout-close', function() {
				closeAllFlyouts(true);
			})
			.on('header.openpopup', function(event, customEvent) {
				if (!customEvent.container.hasClass('b-utility_popup-item')) {
					$(':ui-dialog').dialog('close');
					$cache.utilityFlyoutLinks.removeClass('active');
					$cache.body.removeClass(options.classBody);
				}
			})
			.on('dialogopen', function(e, ui) {
				var $dialogParent = $(e.target).parent(),
					isServiceDialog = $dialogParent.hasClass('dialog-customer_services'),
					isNewsletterDialog = $dialogParent.hasClass('dialog-newsletter_subscribe');

				if (isServiceDialog || isNewsletterDialog) {
					$dialogParent.css('margin-top', $('.js-sticky_header').height());
					$cache.body.addClass(options.classBody);

					if (isServiceDialog) $('.js-customer-service-dialog').addClass('active');
					if (isNewsletterDialog) $('.js-newsletter-subscribe-dialog').addClass('active');
				} else {
					closeAllFlyouts(true);
				}
			})
			.on('dialogclose', function(e) {
				!!$(e.target).is('#service-dialog') && closeAllFlyouts(true);
			})
			.on('keydown', function(e) {
				if (e.keyCode === 27 && ($('.js-main_navigation').hasClass('active') || $cache.selectedLocale.hasClass('active') || $cache.currentCountry.hasClass('active'))) {
					header.closeUtilityPopups();
					closeAllActiveNavItems();
				}
				if (e.keyCode === 27 && $cache.body.hasClass('js-header-flyout_opened')) {
					closeAllFlyouts(true);
				}
			});
	}

	levelMenuToggle();
}

function closeAllActiveNavItems() {
	$cache.headerNavigation.find('.open-level').removeClass('open-level');
	$cache.headerNavigationItems.removeClass('active');
	$cache.headerNavigationDropdowns.hide();
}

function closeAllFlyouts(hideOverlay) {
	$(':ui-dialog').filter('#service-dialog').dialog('close');
	$cache.utilityFlyoutPopups.removeClass('active');
	$cache.utilityFlyoutLinks.removeClass('active');
	!!hideOverlay && $cache.body.removeClass(options.classBody);
}

/**
 * Determines whether header promotion block needs to be hidden
 *
 * @returns {Boolean}
 */
function needHideHeaderPromotion() {
	var $headerPromoSlot = null,
		$headerPromoSlotAssets = null;

	if (SitePreferences.HIDE_HEADER_PROMOTION) {
		return true;
	}

	$headerPromoSlot = $(options.selectors.headerPromoSlot);
	$headerPromoSlotAssets = $headerPromoSlot.find(options.selectors.contentAssetWrapper);

	return $headerPromoSlotAssets.length === 0;
}

/**
 * Hides header promotion block
 */
function hideHeaderPromotion() {
	$cache.body.addClass(options.classHeaderPromoHidden);
}

//Change header height while resizel
function customHeaderEvents() {
    $cache.window.on('resize', function() {
		if ($cache.header.outerHeight() !== $cache.headerWrapper.outerHeight()) {
			$cache.headerWrapper.height($cache.header.outerHeight());
		}
    });

	$cache.headerNavigation.on('click touchstart', function(e) {
		e.stopPropagation();
	});
}

function levelMenuToggle() {
    $('.js-toggled_menu .menu-item-toggle').on('click', function(e) {
        e.preventDefault();
        var $parentLi = $(e.target).closest('li, .js-navigation-item');

        $parentLi
			.parent().toggleClass('open-level')
			.parent().toggleClass('open-level');
    });
}

module.exports = {
	init : function (params) {
		if (initialized) {
			return;
		}

		initializeCache();
		initializeEvents();
		customHeaderEvents();

		if (needHideHeaderPromotion()) {
			hideHeaderPromotion();
		}

		initialized = true;
	}
}
